import { ShipmentStatusEnum } from '../enum/shipment-status.enum';

export class ShipmentState {
    static isQuotable(state: string): boolean {
        return state === ShipmentStatusEnum.QUOTE ||
            state === ShipmentStatusEnum.QUOTED ||
            state === ShipmentStatusEnum.QUOTING_COMPLETED ||
            state === ShipmentStatusEnum.QUOTING_IN_PROGRESS ||
            state === ShipmentStatusEnum.PREPARING;
    }

    static isSubmitted(state: string): boolean {
        return state === ShipmentStatusEnum.MANIFESTED ||
            state === ShipmentStatusEnum.IN_TRANSIT ||
            state === ShipmentStatusEnum.DELIVERED ||
            state === ShipmentStatusEnum.EXCEPTION ||
            state === ShipmentStatusEnum.VOID;
    }

    static isVoidable(state: string): boolean {
        return state === ShipmentStatusEnum.MANIFESTED;
    }
}
